const form = document.querySelector('.header-search');
const input = document.getElementById('live-search');
const results = document.getElementById('search-results');
const loader = document.getElementById('search-loader');

let debounceTimer;

form.addEventListener('submit', function(e) {
    const value = input.value.trim();
    if (value.length === 0) {
        e.preventDefault();
        window.location.href = "/collections/all";
    }
});

input.addEventListener('input', () => {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
        const q = input.value.trim();

        if (q.length < 2) {
        results.style.display = 'none';
        loader.style.display = 'none';
        results.innerHTML = '';
        return;
        }

        loader.style.display = 'block';
        results.style.display = 'none';

        const res = await fetch(`/search?q=${encodeURIComponent(q)}&type=product`);
        const text = await res.text();

        const html = new DOMParser()
        .parseFromString(text, 'text/html');

        const productLinks = html.querySelectorAll(
        '.product-card a.user-select-text'
        );

        if (!productLinks.length) {
        results.innerHTML = '<div class="search-no-results">No products found</div>';
        return;
        }

        const items = Array.from(productLinks).map(link => ({
        title: link.textContent.trim(),
        url: link.getAttribute('href')
        }));

        items.sort((a, b) => a.title.localeCompare(b.title));

        let output = `<div class="search-results-list"><div class="search-results-heading">Products</div>`;

        items.forEach(item => {
        output += `<a href="${item.url}" class="search-result-item">${item.title}</a>`;
        });

        output += `</div>`;

        results.innerHTML = output;

        loader.style.display = 'none';
        results.style.display = 'block';
    }, 250);
});